import { CalendarMinus, CalendarPlus } from "lucide-react";
import { DatePickerInput } from "@/components/foundations/inputs/DatePickerInput/DatePickerInput";
import { toggleDateSplit } from "@/lib/dateSplit";

type Props = {
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onEndTimeChange?: (value: string) => void;
};

export default function DateSplitInput({
  startDate,
  endDate,
  startTime = "",
  endTime = "",
  onStartDateChange,
  onEndDateChange,
  onEndTimeChange,
}: Props) {
  const splitDate = Boolean(startDate && endDate && startDate !== endDate);

  function toggleSplitDate() {
    const next = toggleDateSplit({ startDate, endDate, startTime, endTime });
    onEndDateChange(next.endDate);
    if (next.endTime !== endTime) onEndTimeChange?.(next.endTime);
  }

  return (
    <div className={`date-split-input field full${splitDate ? " is-split" : ""}`}>
      <DatePickerInput
        dateFormat="short"
        showCalendarIcon={!splitDate}
        value={startDate}
        onChange={onStartDateChange}
      />
      <button
        type="button"
        className="split-button"
        onClick={toggleSplitDate}
        disabled={!startDate}
        aria-pressed={splitDate}
        aria-label={splitDate ? "Use one day" : "Use separate start and end dates"}
        title={splitDate ? "Use one day" : "Use separate start and end dates"}
      >
        {splitDate ? <CalendarMinus /> : <CalendarPlus />}
      </button>
      {splitDate && (
        <DatePickerInput
          dateFormat="short"
          value={endDate}
          onChange={onEndDateChange}
        />
      )}
    </div>
  );
}
